import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { InputAdornment } from "@mui/material";
import { Calendar } from "lucide-react";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { useEffect } from "react";
import { isBefore } from "date-fns";

const DateTimePickerValue: React.FC<{
  value: Date | null;
  onChange: (newValue: Date | null) => void;
  setError: (error: string) => void;
  error: string;
}> = ({ value, onChange, setError, error }) => {
  const screen = useScreenSize();

  const [minDateTime, setMinDateTime] = React.useState<Date>(new Date());

  useEffect(() => {
    const now = new Date();
    setMinDateTime(now);

    if (value && !isBefore(value, now)) {
      setError("");
    } else if (value && !isBefore(value, now)) {
      setError("Date must be in the future");
    }
  }, [value, setError]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DemoContainer components={["DateTimePicker"]}>
        <MobileDateTimePicker
          format="dd/MM/yyyy hh:mm a"
          onChange={onChange}
          label="Next Action Date"
          minDateTime={minDateTime}
          orientation={screen.isMobile ? "portrait" : "landscape"}
          slotProps={{
            textField: {
              helperText: error,

              InputProps: {
                size: "medium",

                endAdornment: (
                  <InputAdornment position="end">
                    <Calendar
                      style={{
                        color: "#848E9C",
                        width: "16px",
                        height: "16px",
                      }}
                    />
                  </InputAdornment>
                ),
              },
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default DateTimePickerValue;
